import { render, staticRenderFns } from "./systemSetting.vue?vue&type=template&id=567f4688&"
import script from "./systemSetting.vue?vue&type=script&lang=js&"
export * from "./systemSetting.vue?vue&type=script&lang=js&"
import style0 from "./systemSetting.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports